import ReturnMessage from "../shared/ReturnMessage";
import SelectInput from "../ui/SelectInput";
import Button from "../ui/Button";
import LoadingOverlay from "../shared/LoadingOverlay";
import usePost from "../../hooks/usePost";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ModalFormWrapper from "../shared/ModalFormWrapper";
import tick from "../../assets/icons/tick-big.svg";
import { dealSourceList, kycHeatList } from "../../data/portalFormListData";
import chevronDown from "../../assets/icons/chevron-down-big-white.svg";

const PortalMoveToKycModal = ({ closeModal, closedBy, dealId, initialKycHeat }) => {
    // State
    const [validateForm, setValidateForm] = useState(false);
    const [reason, setReason] = useState("");
    const [kycHeat, setKycHeat] = useState(initialKycHeat || "");
    const [, setValidateReset] = useState(false);
    const [resetSuccess, setResetSuccess] = useState(false);

    // Hooks
    const { sending: loading, returnMessage } = usePost();
    const { sending, returnData: resetData, returnMessage: resetClosedMessage, postData: postClosed } = usePost();

    // Use effect
    useEffect(() => {
        if (resetData) {
            setResetSuccess(true);
        }
    }, [resetData]);

    // Submit
    const submitHandler = (e) => {
        e.preventDefault();
        setValidateForm(true);
        setValidateReset(true);
        setResetSuccess(false);

        // Form complete
        if (reason && reason.length > 1) {
            // Set data
            let formData = {
                dealSource: reason,
                kycHeat: kycHeat,
                dealId: dealId,
            };

            // Post
            postClosed(formData, "/api/portal/setDealKyc", 1000);
        }
    };

    return (
        <ModalFormWrapper title="Move to KYC">
            <ReturnMessage returnMessage={resetClosedMessage} />

            {loading || sending ? (
                <LoadingOverlay />
            ) : returnMessage.error ? (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__success">
                            <div className="login-form__body__title">Could not progress deal</div>
                            <br />
                            <br />
                            <div className="login-form__body__submit-container">
                                <Link to="/portal">
                                    <Button onClick={closeModal} disabled={sending} classNames={["button--full"]}>
                                        Return
                                    </Button>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            ) : resetSuccess ? (
                <div className="login-form">
                    <div className="login-form__success">
                        <img className="login-form__success__tick" src={tick} alt="" />
                        <div className="login-form__success__message">The deal has been moved to KYC successfully</div>
                        <Button onClick={closeModal}>Return</Button>
                    </div>
                </div>
            ) : (
                <div className="login-form">
                    <div className="login-form__body">
                        <div className="login-form__body__title">You are setting this deal to "Know Your Customer"</div>
                        <div className="login-form__body__intro">Please check the details below</div>

                        <form onSubmit={submitHandler}>
                            <SelectInput
                                value={(value) => setKycHeat(value)}
                                options={kycHeatList}
                                label="KYC Heat*"
                                required
                                chevron={chevronDown}
                                validateForm={validateForm}
                                defaultValue={initialKycHeat}
                                classNames={["select-input--full select-input--form"]}
                            />

                            <SelectInput
                                value={(value) => setReason(value)}
                                options={dealSourceList}
                                label="Deal source*"
                                required
                                chevron={chevronDown}
                                validateForm={validateForm}
                                classNames={["select-input--full select-input--form"]}
                            />

                            <div className="login-form__body__submit-container">
                                <Button disabled={sending} classNames={["button--full"]}>
                                    Save
                                </Button>
                            </div>
                        </form>

                        {sending && <LoadingOverlay />}
                    </div>
                </div>
            )}
        </ModalFormWrapper>
    );
};

export default PortalMoveToKycModal;
